import { RG_TYPE } from "@project-rouge/rg-core";
import { Vector3toV3, applyTransform, getPivot } from "@project-rouge/rg-three";
function getApartmentEntryPosition(apt, pivot = [
	.5,
	0,
	0
]) {
	for (const module of apt.children.filter((c) => c.type === RG_TYPE.Module)) for (const wall of module.children.filter((c) => c.type === RG_TYPE.Wall)) {
		const door = wall.children.find((c) => c.type === RG_TYPE.Door && c.data.isEntrance);
		if (door) return Vector3toV3(applyTransform(applyTransform(getPivot(pivot, door), wall), module));
	}
	return Vector3toV3(getPivot([
		.5,
		0,
		0
	], apt));
}
export { getApartmentEntryPosition };

//# sourceMappingURL=index156.js.map